import { render, staticRenderFns } from "./EmailDataIndex.vue?vue&type=template&id=21b8f5fe&scoped=true"
import script from "./EmailDataIndex.vue?vue&type=script&lang=js"
export * from "./EmailDataIndex.vue?vue&type=script&lang=js"
import style0 from "./EmailDataIndex.vue?vue&type=style&index=0&id=21b8f5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b8f5fe",
  null
  
)

export default component.exports